// cSpell: ignore uccc
import { Navigate, RouteObject } from "react-router-dom";
import { WorkInProgress } from "../components/shared/WorkInProgress";
import { ErrorBoundary } from "../components/ErrorBoundary";

export const linehaulRoutes: RouteObject[] = [
  {
    path: "linehaul",
    lazy: () => import("../pages/linehaul/LinehaulLayout"),
    errorElement: <ErrorBoundary />,
    children: [
      { index: true, element: <Navigate to="load-board" replace /> },
      {
        path: "load-board",
        errorElement: <ErrorBoundary />,
        children: [
          {
            index: true,
            lazy: () => import("../pages/linehaul/loadboard/LinehaulOverview"),
          },
          {
            path: "reship/:sicCode",
            lazy: () => import("../pages/linehaul/reship/Reship"),
          },
          {
            path: "ucccPlanning",
            lazy: () => import("../pages/linehaul/loadboard/UcccPlanning"),
          },
          {
            path: ":originSicCode",
            lazy: () =>
              import("../pages/linehaul/loadboard/ServiceCenterOverview"),
          },
          {
            path: ":originSicCode/:laneDestinationSicCode",
            lazy: () => import("../pages/linehaul/loadboard/LaneOverview"),
          },
          {
            path: ":originSicCode/:laneDestinationSicCode/trip/:tripNumber",
            lazy: () => import("../pages/linehaul/loadboard/TripOverview"),
          },
        ],
      },
      {
        path: "load-board-v1",
        errorElement: <ErrorBoundary />,
        lazy: () => import("../pages/linehaul/loadboard/LoadBoard"),
      },
      {
        path: "load-board-v2",
        children: [
          {
            index: true,
            errorElement: <ErrorBoundary />,
            element: <Navigate to="../load-board" replace />,
          },
          {
            path: "*",
            element: <Navigate to="/linehaul/load-board" replace />,
          },
        ],
      },
      {
        path: "master-schedule",
        errorElement: <ErrorBoundary />,
        lazy: () => import("../pages/linehaul/master-schedule/MasterSchedule"),
      },
      {
        path: "master-schedule-templates",
        errorElement: <ErrorBoundary />,
        children: [
          {
            index: true,
            lazy: () => import("../pages/linehaul/template/Templates"),
          },
          {
            path: ":templateId",
            lazy: () => import("../pages/linehaul/template/Template"),
          },
        ],
      },
      {
        path: "forecasting",
        errorElement: <ErrorBoundary />,
        element: <WorkInProgress />,
      },
      {
        path: "uccc-ofd",
        errorElement: <ErrorBoundary />,
        children: [
          {
            index: true,
            lazy: () =>
              import(
                "../pages/linehaul/ucccOfd/ucccOfdDashboard/UcccOfdDashboard"
              ),
          },
          {
            path: "shipment/:shipmentId",
            lazy: () =>
              import(
                "../pages/linehaul/ucccOfd/ucccOfdDashboard/UcccOfdDashboard"
              ),
          },
          {
            path: "service-failure-recap-report",
            errorElement: <ErrorBoundary />,
            lazy: () =>
              import(
                "../pages/linehaul/ucccOfd/ucccOfdDashboard/ucccOfdServiceFailureRecapReport/ucccOfdServiceFailureRecapReport"
              ),
          },
        ],
      },
      {
        path: "trips-dashboard",
        errorElement: <ErrorBoundary />,
        lazy: () => import("../pages/linehaul/tripsDashboard/TripsDashboard"),
        children: [
          {
            index: true,
            element: <Navigate to="planning?view_week=true" replace />,
          },
          {
            path: "planning",
            lazy: () =>
              import(
                "../pages/linehaul/tripsDashboard/planningTrips/PlanningTripsView"
              ),
          },
          {
            path: "in-transit",
            lazy: () =>
              import("../pages/linehaul/tripsDashboard/inTransit/InTransit"),
            children: [
              {
                path: "trip/:tripNumber",
                lazy: () =>
                  import(
                    "../pages/linehaul/tripsDashboard/inTransit/TransitShipments/TransitShipments"
                  ),
              },
            ],
          },
          {
            path: "delivered-trips",
            errorElement: <ErrorBoundary />,
            lazy: () =>
              import(
                "../pages/linehaul/tripsDashboard/inTransit/DeliveredTrips/DeliveredTripsDashboard"
              ),
          },
          {
            path: "search",
            lazy: () =>
              import(
                "../pages/linehaul/tripsDashboard/tripsDashboardGlobalSearch/TripsDashboardGlobalSearch"
              ),
          },
        ],
      },
      {
        path: "carrier-pay",
        errorElement: <ErrorBoundary />,
        element: <WorkInProgress />,
      },
      {
        path: "equipment-inventory",
        errorElement: <ErrorBoundary />,
        element: <WorkInProgress />,
      },
      {
        path: "reports",
        errorElement: <ErrorBoundary />,
        children: [
          {
            path: "load-plan/:sicCode",
            lazy: () =>
              import("../pages/linehaul/load-plan-report/LoadPlanReport"),
          },
          {
            path: "end-of-shift",
            lazy: () =>
              import("../pages/linehaul/end-of-shift-report/EndOfShiftReport"),
          },
          {
            path: "cancellations",
            lazy: () => import("../pages/linehaul/cancellations/Cancellations"),
          },
        ],
      },
    ],
  },
];
